import isString from 'lodash/isString';

export const formatPhoneNumber = <T>(phoneNumber: T): T | string => {
  if (!isString(phoneNumber) || phoneNumber === 'N/A') {
    return phoneNumber;
  }

  const numbers = phoneNumber?.replace(/[^0-9]/g, '');

  if (!numbers) {
    return '';
  }

  const truncate = numbers.slice(0, 10).split('');
  const phone = truncate.map((item, key) => {
    if (key === 3 || key === 6) {
      return `-${item}`;
    }

    return item;
  });

  return phone.join('');
};

export const clearPhoneNumberFormatting = <T = string>(phoneNumber: T): T | string => {
  return isString(phoneNumber) ? phoneNumber.replace(/-/g, '') : phoneNumber;
};
